import './App.css';
import Header from './components/header';
import Home from './pages/Home';
import Footer from './components/footer';

function App() {
  return (
    <>
      <Header />
      <Home />
      <Footer />
    </>
  );
}

export default App;
